import type { TenantMapping } from '@vp/ubik-fragment-types'

const TENANT_MAPPINGS_DOM_ID = 'ubik-tenant-mappings'
const TENANT_RESOLVE_URL = 'https://api.experience.cimpress.io/tenants/v1/resolve'

type TenantResolveResponse = {
  tenantMapping: TenantMapping
}

export const readTenantMappingsFromDom = (): TenantMapping | undefined => {
  const rawData = document.getElementById(TENANT_MAPPINGS_DOM_ID)
  const innerText = rawData?.innerText
  if (!innerText) {
    return undefined
  }
  try {
    return JSON.parse(innerText) as TenantMapping
  } catch (e) {
    console.warn('Failed to parse tenant mappings from DOM:', e)
    return undefined
  }
}

export const fetchTenantMappings = async (tenant: string, locale: string, signal?: AbortSignal): Promise<TenantMapping | undefined> => {
  const url = `${TENANT_RESOLVE_URL}?tenant=${encodeURIComponent(tenant)}&locale=${encodeURIComponent(locale)}`
  try {
    const response = await fetch(url, { signal })
    if (!response.ok) {
      console.warn(`Failed to fetch tenant mappings for tenant "${tenant}" locale "${locale}": ${response.status}`)
      return undefined
    }
    const data = (await response.json()) as TenantResolveResponse
    return data.tenantMapping
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      throw error
    }
    console.warn(`Error fetching tenant mappings for tenant "${tenant}" locale "${locale}":`, error)
    return undefined
  }
}

export const createTenantMapping = async (tenant: string | undefined, locale: string): Promise<TenantMapping | undefined> => {
  const fromDom = readTenantMappingsFromDom()
  if (fromDom) {
    return fromDom
  }

  if (!tenant) {
    return undefined
  }

  return fetchTenantMappings(tenant, locale)
}
